<template>
  <div class="reportsWrapper">
    <div class="reportsPdf" ref="document">
      <div class="container-fluid" id="content">
        <div class="pt-4 pb-3 border--bottom-gray">
          <h5 class="txt--semi-bold txt--black mb-2">{{$t('REPORT')}}</h5>
          <p class="txt--semi-bold txt--off-black txt--ss">{{range}}</p>
        </div>
        <div class="py-3 border--bottom-gray">
          <div class="row">
            <div class="col-auto customers-records">
              <p class="txt--ss txt--off-black txt--semi-bold">{{$t('TC')}}</p>
              <p
                class="txt--fslg txt--black txt--semi-bold pt-2"
              >{{data.quick_report.transient_customer}}</p>
              <p
                :class="['transient-customers-records txt--ss mt-3',data.quick_report.transient_customer_inc ? 'txt--green' : 'txt--red']"
              >
                <span
                  :class="[data.quick_report.transient_customer_inc ? 'txt--green' : 'txt--red','rounded-circle']"
                ></span>
                {{data.quick_report.transient_customer_inc_value}}%
              </p>
            </div>
            <div class="col-auto customers-records">
              <p class="txt--ss txt--off-black txt--semi-bold">{{$t('MC')}}</p>
              <p
                class="txt--fslg txt--black txt--semi-bold pt-2"
              >{{data.quick_report.monthly_customer}}</p>
              <p
                :class="['transient-customers-records txt--ss mt-3',data.quick_report.monthly_customer_inc ? 'txt--red' : 'txt--red']"
              >
                <span
                  :class="[data.quick_report.monthly_customer_inc ? 'txt--red' : 'txt--red','rounded-circle']"
                ></span>
                {{data.quick_report.monthly_customer_inc_value}}%
              </p>
            </div>
            <div class="col-auto customers-records">
              <p class="txt--ss txt--off-black txt--semi-bold">{{$t('AC')}}</p>
              <p
                class="txt--fslg txt--black txt--semi-bold pt-2"
              >{{data.quick_report.anonymous_customer}}</p>
              <p
                :class="['transient-customers-records txt--ss mt-3',data.quick_report.anonymous_customer_inc ? 'txt--red' : 'txt--red']"
              >
                <span
                  :class="[data.quick_report.anonymous_customer_inc ? 'txt--red' : 'txt--red','rounded-circle']"
                ></span>
                {{data.quick_report.anonymous_customer_inc_value}}%
              </p>
            </div>
            <!--{{--
            <div class="col-auto customers-records">
              <p class="txt--ss txt--off-black txt--semi-bold">{{$t('AVGSD')}}</p>
              <p
                class="txt--fslg txt--black txt--semi-bold pt-2"
              >{{data.quick_report.avg_session_duration}}</p>
              <p
                :class="['transient-customers-records txt--ss mt-3',data.quick_report.avg_session_duration_inc ? 'txt--green' : 'txt--red']"
              >
                <span
                  :class="[data.quick_report.avg_session_duration_inc ? 'txt--green' : 'txt--red','rounded-circle']"
                ></span>
                {{data.quick_report.avg_session_duration_inc_value}}%
              </p>
            </div>
            <div class="col-auto customers-records">
              <p class="txt--ss txt--off-black txt--semi-bold">{{$t('AVGSP')}}</p>
              <p
                class="txt--fslg txt--black txt--semi-bold pt-2"
              >${{data.quick_report.avg_session_price}}</p>
              <p
                :class="['transient-customers-records txt--ss mt-3 ',data.quick_report.avg_session_price_inc ? 'txt--green' : 'txt--red']"
              >
                <span
                  :class="[data.quick_report.avg_session_price_inc ? 'txt--green' : 'txt--red','rounded-circle']"
                ></span>
                {{data.quick_report.avg_session_price_inc_value}}%
              </p>
            </div>
          </div>
          --}}-->
        </div>
        <div class="py-3 border--bottom-gray">
          <div class="row">
            <div class="col-4">
              <div class="reportExportGraph">
                <p class="txt--xs txt--off-black txt--semi-bold mb-2">{{$t('SESSION')}}</p>
                <p class="txt--xs txt--black txt--semi-bold mb-2">{{data.session_total}}</p>
                <p
                  :class="['transient-customers-records txt--xs',data.session_inc ? 'txt--green' : 'txt--red']"
                >
                  <span :class="[data.session_inc ? 'txt--green' : 'txt--red','rounded-circle']"></span>
                  {{data.session_inc_value}}%
                </p>
                <div class="reportExportGraph__graph">
                  <section class="charts">
                    <vue-highcharts
                      :highcharts="Highcharts"
                      :options="sessionOptions"
                      ref="drilldownChart"
                    ></vue-highcharts>
                  </section>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="reportExportGraph">
                <p class="txt--xs txt--off-black txt--semi-bold mb-2">{{$t('EARN')}}</p>
                <p class="txt--xs txt--black txt--semi-bold mb-2">${{data.earning_total}}</p>
                <p
                  :class="['transient-customers-records txt--xs',data.earning_inc ? 'txt--green' : 'txt--red']"
                >
                  <span :class="[data.earning_inc ? 'txt--green' : 'txt--red','rounded-circle']"></span>
                  {{data.earning_inc_value}}%
                </p>
                <div class="reportExportGraph__graph">
                  <section class="charts">
                    <vue-highcharts
                      :highcharts="Highcharts"
                      :options="earningsOptions"
                      ref="drilldownChart"
                    ></vue-highcharts>
                  </section>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="reportExportGraph">
                <p class="txt--xs txt--off-black txt--semi-bold mb-2">{{$t('OCCUP')}}</p>
                <p class="txt--xs txt--black txt--semi-bold mb-2">{{data.occupancy_total}}%</p>
                <p
                  :class="['transient-customers-records txt--xs',data.occupancy_inc?'txt--green':'txt--red']"
                >
                  <span :class="[data.occupancy_inc?'txt--green':'txt--red','rounded-circle']"></span>
                  {{data.occupancy_inc_percentage}}%
                </p>
                <div class="reportExportGraph__graph">
                  <section class="charts">
                    <vue-highcharts
                      :highcharts="Highcharts"
                      :options="occupancyOptions"
                      ref="drilldownChart"
                    ></vue-highcharts>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="py-3">
          <table class="table table-borderless report__export__table">
            <thead>
              <tr>
                <th scope="col" width="25%">
                  <p class="report__txt__header txt--off-black">{{$t('PROPES')}}</p>
                </th>
                <th scope="col" width="10%">
                  <p class="report__txt__header txt--off-black">{{$t('SESSION')}}</p>
                </th>
                <th scope="col" width="10%">
                  <p class="report__txt__header txt--off-black">
                    {{$t('TC')}}
                  </p>
                </th>
                <th scope="col" width="10%">
                  <p class="report__txt__header txt--off-black">
                   {{$t('MC')}}
                  </p>
                </th>
                <th scope="col" width="10%">
                  <p class="report__txt__header txt--off-black">
                    {{$t('AC')}}
                  </p>
                </th>
                <th scope="col" width="10%">
                  <p class="report__txt__header txt--off-black">{{$t('OCCUP')}}</p>
                </th>
                <th scope="col" width="10%">
                  <p class="txt--xs txt--off-black">{{$t('EARN')}}</p>
                </th>
              </tr>
            </thead>
            <tbody v-if="data.property_details_report.length > 0">
              <tr v-for="(report , index) in data.property_details_report" :key="index">
                <td width="25%">
                  <p class="txt--xs">{{report.address}}</p>
                </td>
                <td width="10%">
                  <p class="txt--xs">{{report.total_session}}</p>
                </td>
                <td width="10%">
                  <p class="txt--xs">{{report.total_transient_customer}}</p>
                </td>
                <td width="10%">
                  <p class="txt--xs">{{report.total_monthly_customer}}</p>
                </td>
                <td width="10%">
                  <p class="txt--xs">{{report.total_anonymous_customer}}</p>
                </td>
                <td width="10%">
                  <p class="txt--xs">{{report.occupied_percent}}%</p>
                </td>
                <td width="10%">
                  <p class="txt--xs">${{report.total_earning}}</p>
                </td>
              </tr>
              <!-- <tr>
                <td width="25%">
                  <p class="txt--xs">601 Van Ness Ave</p>
                </td>
                <td width="15%">
                  <p class="txt--xs">1,537</p>
                </td>
                <td width="15%">
                  <p class="txt--xs">1,489</p>
                </td>
                <td width="15%">
                  <p class="txt--xs">48</p>
                </td>
                <td width="15%">
                  <p class="txt--xs">87%</p>
                </td>
                <td width="15%">
                  <p class="txt--xs">$59,328.20</p>
                </td>
              </tr>
              <tr>
                <td width="25%">
                  <p class="txt--xs">750 O’Farrell St</p>
                </td>
                <td width="15%">
                  <p class="txt--xs">2,070</p>
                </td>
                <td width="15%">
                  <p class="txt--xs">2,008</p>
                </td>
                <td width="15%">
                  <p class="txt--xs">62</p>
                </td>
                <td width="15%">
                  <p class="txt--xs">82%</p>
                </td>
                <td width="15%">
                  <p class="txt--xs">$79,902.00</p>
                </td>
              </tr>-->
            </tbody>
          </table>
        </div>
      </div>
      <!-- <div id="canvas"></div> -->
    </div>
    </div>
  </div>
</template>

<script>
import VueHighcharts from "vue2-highcharts";
import Highcharts from "highcharts";
// import jsPDF from 'jspdf';
// import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";
export default {
  name: "reportPdf",
  components: {
    VueHighcharts,
  },
  data() {
    return {
      Highcharts: Highcharts,
      sessionOptions: {
        lang: {
          drillUpText: "back",
        },
        chart: {
          type: "column",
          backgroundColor: "transparent",
          height: 150,
        },
        title: {
          text: "",
        },
        xAxis: {
          type: "category",
          title: {
            text: "",
          },
          labels: {
            style: {
              color: "#121212",
              fontSize: "7px",
              fontWeight: 600,
              textDecoration: "none",
            },
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "",
          },
          gridLineDashStyle: "longdash",
          gridLineWidth: 1,
          tickInterval: 200,
          labels: {
            style: {
              color: "#000",
              fontSize: "7px",
              fontWeight: 600,
              textDecoration: "none",
              opacity: 0.5,
            },
          },
        },
        legend: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            borderRadius: 2,
            dataLabels: {
              enabled: false,
            },
          },
        },
        tooltip: {
          valueSuffix: "",
          shared: false,
          enabled: true,
          pointFormat: "{point.y:.0f} Sessions",
          headerFormat: "",
        },
        colors: ["#F5A623"],
        series: [
          {
            name: "April",
            colorByPoint: false,
            data: [],
          },
        ],
      },
      earningsOptions: {
        lang: {
          drillUpText: "back",
        },
        chart: {
          type: "column",
          backgroundColor: "transparent",
          height: 150,
        },
        title: {
          text: "",
        },
        xAxis: {
          type: "category",
          title: {
            text: "",
          },
          labels: {
            style: {
              color: "#121212",
              fontSize: "7px",
              fontWeight: 600,
              textDecoration: "none",
            },
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "",
          },
          gridLineDashStyle: "longdash",
          gridLineWidth: 1,
          labels: {
            format: "${value}K",
            style: {
              color: "#000",
              fontSize: "7px",
              fontWeight: 600,
              textDecoration: "none",
              opacity: 0.5,
            },
          },
        },
        legend: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            borderRadius: 2,
            dataLabels: {
              enabled: false,
            },
          },
        },
        tooltip: {
          valueSuffix: "",
          shared: false,
          enabled: true,
          pointFormat: "{point.y:.0f} Earnings",
          headerFormat: "",
        },
        colors: ["#F5A623"],
        series: [
          {
            name: "April",
            colorByPoint: false,
            data: [],
          },
        ],
      },
      occupancyOptions: {
        lang: {
          drillUpText: "back",
        },
        chart: {
          type: "column",
          backgroundColor: "transparent",
          height: 150,
        },
        title: {
          text: "",
        },
        xAxis: {
          type: "category",
          title: {
            text: "",
          },
          labels: {
            style: {
              color: "#121212",
              fontSize: "7px",
              fontWeight: 600,
              textDecoration: "none",
            },
          },
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: "",
          },
          gridLineDashStyle: "longdash",
          gridLineWidth: 1,
          labels: {
            format: "{value}%",
            style: {
              color: "#000",
              fontSize: "7px",
              fontWeight: 600,
              textDecoration: "none",
              opacity: 0.5,
            },
          },
        },
        legend: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            borderRadius: 2,
            dataLabels: {
              enabled: false,
            },
          },
        },
        tooltip: {
          valueSuffix: "",
          shared: false,
          enabled: true,
          pointFormat: "{point.y:.2f}%",
          headerFormat: "",
        },
        colors: ["#F5A623"],
        series: [
          {
            name: "April",
            colorByPoint: false,
            data: [],
          },
        ],
      },
      data: {},
      range: "",
      html2pdfOpt: {
        margin: 10,
        filename: `Report.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          dpi: 192,
          letterRendering: false,
          allowTaint: true,
          logging: false,
        },
        jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
      },
    };
  },
  created() {
    this.$toasted.show(
      "Your file will be downloaded soon. Please do not naviagte away from the page!",
      {
        icon: "check-circle",
        className: "success-class",
      }
    );
    let data = localStorage.getItem("print_data");
    this.data = JSON.parse(data);
    console.log(this.data);
    this.sessionOptions.series[0].data = this.data.session_chart;
    this.earningsOptions.series[0].data = this.data.earning_chart;
    this.occupancyOptions.series[0].data = this.data.occupancy_report;
    this.range =
      this.$moment(this.data.start_date).format("MMM D") +
      " - " +
      this.$moment(this.data.end_date).format("MMM D,YYYY");
    this.html2pdfOpt.filename = "Report_" + this.range + ".pdf";
  },
  mounted() {
    setTimeout(() => {
      this.exportToPDF();
    }, 3000);
  },
  methods: {
    exportToPDF() {
      html2pdf()
        .from(this.$refs.document)
        .set(this.html2pdfOpt)
        .toPdf()
        .get("pdf")
        .then(function (pdf) {
          var totalPages = pdf.internal.getNumberOfPages();

          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(8);
            pdf.setTextColor("#7f7f7f");
            pdf.text(
              "Page " + i + " of " + totalPages,
              pdf.internal.pageSize.getWidth() - 70,
              pdf.internal.pageSize.getHeight() - 20
            );
          }
        })
        .save();
    },
  },
};
</script>

<style>
.charts {
  height: 100%;
}
.highcharts-yaxis-grid .highcharts-grid-line {
  stroke-width: 0.5px;
  stroke: rgba(0, 0, 0, 0.1);
}
.highcharts-xaxis .highcharts-axis-line {
  display: none;
}
/* .html2canvas-container {
  width: 800px !important;
} */
</style>